import conf from "@conf";
import VConsole from "vconsole";
import { isWeChat, isWxWork } from "./device";

const console = window.console;
const log = window.console.info.bind(console);
const err = window.console.error.bind(console);
let vConsole = null;
class CustomerLogger {
  constructor(config) {
    if (config.isDevelopment || config.enableVConsole) {
      this.log = window.console.log = log.bind(
        console,
        `[ REMOTE-SALES v${conf.VERSION} ]`
      );
    } else {
      window.console.log = () => {};
    }
    this.error = window.console.error = err.bind(
      console,
      `[ REMOTE-SALES v${conf.VERSION} ]`
    );

    if (isWeChat && config.enableVConsole) {
      vConsole = new VConsole({ maxLogNumber: 1000 });
    }
  }

  printEnv() {
    const tags = [
      `REMOTE-SALES v${conf.VERSION}`,
      `Commit ID ${process.env.GIT_COMMIT_ID}`,
      conf.isDevelopment ? "开发环境" : "生产环境",
      isWxWork
        ? "企微环境"
        : isWeChat
        ? "微信环境"
        : conf.isDevelopAsInWxWork
        ? "伪企微环境"
        : conf.isDevelopAsInWeChat
        ? "伪微信环境"
        : "---",
    ];
    if (conf.isMockEnabled) {
      tags.push("MockAPI Enabled");
    }
    if (vConsole) {
      tags.push("VConsole Enabled");
    }
    console.info(`[ ${tags.join(" | ")} ]`);
    return this;
  }
}

const logger = new CustomerLogger({ ...conf }).printEnv();
export default logger;
